import React from 'react';

import { Alert, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useContainer } from 'unstated-next';

import UsersTableLoading from './UsersTableLoading';
import { useOrgSettings } from '../../../../hooks/useOrgSettings';
import { Status } from '../../../../types/apiTypes';
import AdminUsersContainer from '../../AdminUsersContainer';
import UserControl from '../UserControl';

const StyledTable = styled(Table)`
    margin-bottom: 2rem;
`;

const Spacer = styled.div`
    margin: 2rem;
`;

export interface UsersTablePaginationProps {}

const UsersTableBody: React.FC<UsersTablePaginationProps> = () => {
    const { users, status, error } = useContainer(AdminUsersContainer);
    const { t } = useTranslation('admin_settings');
    const { data: orgSettings } = useOrgSettings();
    
    if (error) {
        return (
            <>
                <Spacer />
                <Alert severity={'error'}>{t('error.userError')}</Alert>
            </>
        );
    }

    if (status === Status.InProgress) {
        return <UsersTableLoading />;
    }

    if (!users.length) {
        return (
            <>
                <Spacer />
                <Alert severity={'info'}>{t('users.no-users-found')}</Alert>
                <Spacer />
            </>
        );
    }

    return (
        <StyledTable>
            <TableHead>
                <TableRow>
                    <TableCell>{t('users.username')}</TableCell>
                    <TableCell>{t('users.email')}</TableCell>
                    {orgSettings?.featureSettings.options.useIdentifierInRoster && <TableCell>{t('users.ext-user-id')}</TableCell>}
                    <TableCell>{t('users.roles')}</TableCell>
                    <TableCell>{t('users.user-actions')}</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {users.map((user) => (
                    <UserControl key={user.user_id} user={user} />
                ))}
            </TableBody>
        </StyledTable>
    );
};

export default UsersTableBody;
